import React, { Component } from 'react';
import { Wrapper } from './LinkStyle';
class Link extends Component {
	render() {
		return <Wrapper as={this.props.type || null} {...this.props}>{this.props.children}</Wrapper>;
	}
}

export default Link;
